import React, { Component } from 'react';
import { Icon, Modal, Row, Col, Button } from 'react-materialize'
import Indicator from '../data/IndicatorValueMap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CountrySelector from './CountrySelector';
import CountryTags from './CountryTags';
import { connect } from "react-redux";

class ModalView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: props.modalDisplay
    };
  }

  closeModal(){
    this.setState({ open: false })
  }


  render() {
    const { demographicSelected, sedentarySelected,
            dietSelected, tobaccoSelected, alcoholSelected, overweightSelected,
            countries, mentalSelected
            } = this.props;
    const { open } = this.state;
    return (
        <Modal
          id='indicatorModal'
          open={open}
          actions = ""
          >
          <div className='modal-phone' onClick={()=>{this.closeModal()}}>
            <Row className='modal-phone-header'>
                <span style={{ width: '144px'}}>
                  Select an Indicator to Start
                </span>
                <span style={{ fontWeight: 'bold', marginLeft: "30%"}}>
                  <Icon>arrow_forward</Icon>
                </span>
            </Row>
          </div>
          {
            !demographicSelected && !sedentarySelected && !dietSelected && !tobaccoSelected && !alcoholSelected && !overweightSelected && !mentalSelected?(
          <div className='indicatorModal'>
            <Row className='modal-header'>
                Select an Indicator
            </Row>
            <Row className='modal-selector-row'>
              <Col s='4'>
                <div className='modal-selector' onClick={() => this.props.demoClick()}>
                  <div className="menu-label">{Indicator["demo"]}</div>
                  <FontAwesomeIcon icon="angle-right" />
                </div>
              </Col>
              <Col s='4'>
                <div className='modal-selector' onClick={() => this.props.sedentaryClick()}>
                  <div className="menu-label">{Indicator["sedentary"]}</div>
                  <FontAwesomeIcon icon="angle-right" />
                </div>
              </Col>
              <Col s='4'>
                <div className='modal-selector' onClick={() => this.props.dietClick()}>
                  <div className="menu-label">{Indicator["diet"]}</div>
                  <FontAwesomeIcon icon="angle-right" />
                </div>
              </Col>
            </Row>
            <Row className='modal-selector-row'>
              <Col s='4'>
                <div className='modal-selector' onClick={() => this.props.tobaccoClick()}>
                  <div className="menu-label">{Indicator["tobacco"]}</div>
                  <FontAwesomeIcon icon="angle-right" />
                </div>
              </Col>
              <Col s='4'>
                <div className='modal-selector' onClick={() => this.props.alcoholClick()}>
                  <div className="menu-label">{Indicator["alcohol"]}</div>
                  <FontAwesomeIcon icon="angle-right" />
                </div>
              </Col>
              <Col s='4'>
                <div className='modal-selector' onClick={() => this.props.overweightClick()}>
                  <div className="menu-label">{Indicator["overweight"]}</div>
                  <FontAwesomeIcon icon="angle-right" />
                </div>
              </Col>
            </Row>
            <Row className='modal-selector-row'>
              <Col s='4'>
                <div className='modal-selector' onClick={() => this.props.mentalClick()}>
                  <div className="menu-label">{Indicator["mental"]}</div>
                  <FontAwesomeIcon icon="angle-right" />
                </div>
              </Col>
            </Row>
          </div>):(
              <div className='indicatorModal-sub'>
                <Row className='modal-header'>
                    Select an Indicator to Start
                </Row>
                <hr/>
                {
                  demographicSelected? <Row className='modal-indicator-title' style={{cursor: "pointer"}} onClick={() => this.props.demoClick()}><FontAwesomeIcon icon="angle-left" style={{marginRight: "1%"}} />{Indicator["demo"]}</Row>: ""
                }
                {
                  sedentarySelected? <Row className='modal-indicator-title' style={{cursor: "pointer"}} onClick={() => this.props.sedentaryClick()}><FontAwesomeIcon icon="angle-left" style={{marginRight: "1%"}} />{Indicator["sedentary"]}</Row>: ""
                }
                {
                  dietSelected? <Row className='modal-indicator-title' style={{cursor: "pointer"}} onClick={() => this.props.dietClick()}><FontAwesomeIcon icon="angle-left" style={{marginRight: "1%"}} />{Indicator["diet"]}</Row>: ""
                }
                {
                  tobaccoSelected? <Row className='modal-indicator-title' style={{cursor: "pointer"}} onClick={() => this.props.tobaccoClick()}><FontAwesomeIcon icon="angle-left" style={{marginRight: "1%"}} />{Indicator["tobacco"]}</Row>: ""
                }
                {
                  alcoholSelected? <Row className='modal-indicator-title' style={{cursor: "pointer"}} onClick={() => this.props.alcoholClick()}><FontAwesomeIcon icon="angle-left" style={{marginRight: "1%"}} />{Indicator["alcohol"]}</Row>: ""
                }
                {
                  overweightSelected? <Row className='modal-indicator-title' style={{cursor: "pointer"}} onClick={() => this.props.overweightClick()}><FontAwesomeIcon icon="angle-left" style={{marginRight: "1%"}} />{Indicator["overweight"]}</Row>: ""
                }
                {
                  mentalSelected? <Row className='modal-indicator-title' style={{cursor: "pointer"}} onClick={() => this.props.mentalClick()}><FontAwesomeIcon icon="angle-left" style={{marginRight: "1%"}} />{Indicator["mental"]}</Row>: ""
                }
                <hr/>
                {
                  this.props.demographicSelected?(
                    <div className="modal-indicator-radio-group">
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="demo-1" name="demographic" onClick={(e)=>{this.props.demoValueChange(e); this.closeModal()}} className={this.props.demoValue === 'demo-1'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["demo-1"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-1-i"]}</div>
                            </div>
                        </div>
                      </div>
                      <div className="modal-indicator-radio">
                          <div style={{display: "flex", alignItems: "center"}}>
                            <div>
                              <Button onClick={(e)=>{this.props.demoValueChange(e); this.closeModal()}} type="button" value="demo-2" name="demographic" className={this.props.demoValue === 'demo-2'?"radio selected":"radio"} />
                            </div>
                            <div className="modal-indicator-label">
                              {Indicator["demo-2"]}
                            </div>
                          </div>
                          <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-2-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" onClick={(e)=>{this.props.demoValueChange(e); this.closeModal()}} value="demo-3" name="demographic" className={this.props.demoValue === 'demo-3'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["demo-3"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-3-i"]}</div>
                            </div>
                        </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="demo-4" onClick={(e)=>{this.props.demoValueChange(e); this.closeModal()}} name="demographic" className={this.props.demoValue === 'demo-4'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["demo-4"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-4-i"]}</div>
                            </div>
                        </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="demo-5" name="demographic" onClick={(e)=>{this.props.demoValueChange(e); this.closeModal()}} className={this.props.demoValue === 'demo-5'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["demo-5"]}
                          </div>
                        </div>
                          <div s={2}>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["demo-5-i"]}</div>
                            </div>
                          </div>
                      </div>
                    </div>
                  ):""
                }
                {
                  this.props.sedentarySelected?(
                    <div className="modal-indicator-radio-group">
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="sedentary-1" name="sendentary" onClick={(e)=> {this.props.sedentaryValueChange(e); this.closeModal()}} className={this.props.sedentaryValue === 'sedentary-1'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["sedentary-1"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["sedentary-1-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="sedentary-2" name="sedentary" onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeModal()}} className={this.props.sedentaryValue === 'sedentary-2'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["sedentary-2"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["sedentary-2-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="sedentary-3" name="sedentary" onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeModal()}} className={this.props.sedentaryValue === 'sedentary-3'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["sedentary-3"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["sedentary-3-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="sedentary-4" name="sedentary" onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeModal()}} className={this.props.sedentaryValue === 'sedentary-4'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["sedentary-4"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["sedentary-4-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="sedentary-5" name="sedentary" onClick={(e)=>{this.props.sedentaryValueChange(e); this.closeModal()}} className={this.props.sedentaryValue === 'sedentary-5'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["sedentary-5"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["sedentary-5-i"]}</div>
                            </div>
                          </div>
                      </div>
                    </div>
                  ):""
                }
                {
                  this.props.dietSelected?(
                    <div className="modal-indicator-radio-group">
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="diet-1" name="diet"  onClick={(e)=>{{this.props.dietValueChange(e); this.closeModal()}; this.closeModal()}} className={this.props.dietValue === 'diet-1'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["diet-1"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                                {Indicator["diet-1-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="diet-2" name="diet" onClick={(e)=>{this.props.dietValueChange(e); this.closeModal()}} className={this.props.dietValue === 'diet-2'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["diet-2"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["diet-2-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="diet-3" name="diet" onClick={(e)=>{this.props.dietValueChange(e); this.closeModal()}} className={this.props.dietValue === 'diet-3'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["diet-3"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["diet-3-i"]}</div>
                            </div>
                          </div>
                      </div>
                    </div>
                  ):""
                }
                {
                  this.props.tobaccoSelected?(
                    <div className="modal-indicator-radio-group">
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                              <Button type="button" value="tobacco-1" name="tobacco" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} className={this.props.tobaccoValue === 'tobacco-1'?"radio selected":"radio"} />
                            </div>
                            <div className="modal-indicator-label">
                              {Indicator["tobacco-1"]}
                            </div>
                          </div>
                          <div>
                              <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["tobacco-1-i"]}</div>
                            </div>
                          </div>
                      </div>
                        <div className="modal-indicator-radio">
                          <div style={{display: "flex", alignItems: "center"}}>
                            <div>
                              <Button type="button" value="tobacco-2" name="tobacco" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} className={this.props.tobaccoValue === 'tobacco-2'?"radio selected":"radio"} />
                            </div>
                            <div className="modal-indicator-label">
                              {Indicator["tobacco-2"]}
                            </div>
                          </div>
                          <div>
                              <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["tobacco-2-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="tobacco-3" name="tobacco" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} className={this.props.tobaccoValue === 'tobacco-3'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["tobacco-3"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["tobacco-3-i"]}</div>
                            </div>
                          </div>
                      </div>
                        <div className="modal-indicator-radio">
                          <div style={{display: "flex", alignItems: "center"}}>
                            <div>
                            <Button type="button" value="tobacco-4" name="tobacco" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} className={this.props.tobaccoValue === 'tobacco-4'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["tobacco-4"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                            <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                            {Indicator["tobacco-4-i"]}</div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="tobacco-5" name="tobacco" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} className={this.props.tobaccoValue === 'tobacco-5'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["tobacco-5"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                            <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                            {Indicator["tobacco-5-i"]}</div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="tobacco-6" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} name="tobacco" className={this.props.tobaccoValue === 'tobacco-6'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["tobacco-6"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                            <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                            {Indicator["tobacco-6-i"]}</div>
                          </div>
                        </div>
                      </div>
                        <div className="modal-indicator-radio">
                          <div style={{display: "flex", alignItems: "center"}}>
                            <div>
                              <Button type="button" value="tobacco-7" name="tobacco" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} className={this.props.tobaccoValue === 'tobacco-7'?"radio selected":"radio"} />
                            </div>
                            <div className="modal-indicator-label">
                              {Indicator["tobacco-7"]}
                            </div>
                          </div>
                          <div>
                              <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                                <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                                {Indicator["tobacco-7-i"]}</div>
                              </div>
                            </div>
                      </div>
                        <div className="modal-indicator-radio">
                          <div style={{display: "flex", alignItems: "center"}}>
                            <div>
                            <Button type="button" value="tobacco-8" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} name="tobacco" className={this.props.tobaccoValue === 'tobacco-8'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["tobacco-8"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                            <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                            {Indicator["tobacco-8-i"]}</div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="tobacco-9" onClick={(e)=>{this.props.tobaccoValueChange(e); this.closeModal()}} name="tobacco" className={this.props.tobaccoValue === 'tobacco-9'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["tobacco-9"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                            <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                            {Indicator["tobacco-9-i"]}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ):""
                }
                {
                  this.props.alcoholSelected?(
                    <div className="modal-indicator-radio-group">
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="alcohol-1"  onClick={(e)=>{this.props.alcoholValueChange(e); this.closeModal()}} name="alcohol" className={this.props.alcoholValue === 'alcohol-1'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["alcohol-1"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                                {Indicator["alcohol-1-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="alcohol-2" onClick={(e)=>{this.props.alcoholValueChange(e); this.closeModal()}} name="alcohol" className={this.props.alcoholValue === 'alcohol-2'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["alcohol-2"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["alcohol-2-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="alcohol-3" onClick={(e)=>{this.props.alcoholValueChange(e); this.closeModal()}} name="alcohol" className={this.props.alcoholValue === 'alcohol-3'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["alcohol-3"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["alcohol-3-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="alcohol-4" onClick={(e)=>{this.props.alcoholValueChange(e); this.closeModal()}} name="alcohol" className={this.props.alcoholValue === 'alcohol-4'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["alcohol-4"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["alcohol-4-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="alcohol-5" onClick={(e)=>{this.props.alcoholValueChange(e); this.closeModal()}} name="alcohol" className={this.props.alcoholValue === 'alcohol-5'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["alcohol-5"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["alcohol-5-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="alcohol-6" name="alcohol" onClick={(e)=>{this.props.alcoholValueChange(e); this.closeModal()}} className={this.props.alcoholValue === 'alcohol-6'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["alcohol-6"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["alcohol-6-i"]}</div>
                            </div>
                          </div>
                      </div>
                    </div>
                  ):""
                }
                {
                  this.props.overweightSelected?(
                    <div className="modal-indicator-radio-group">
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="overweight-1" onClick={(e)=>{this.props.overweightValueChange(e); this.closeModal()}} name="overweight" className={this.props.overweightValue === 'overweight-1'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["overweight-1"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["overweight-1-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="overweight-2" name="overweight" onClick={(e)=>{this.props.overweightValueChange(e); this.closeModal()}} className={this.props.overweightValue === 'overweight-2'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["overweight-2"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["overweight-2-i"]}</div>
                            </div>
                          </div>
                      </div>
                    </div>
                  ):""
                }
                {
                  this.props.mentalSelected?(
                    <div className="modal-indicator-radio-group">
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="mental-1" name="mental" onClick={(e)=>{this.props.mentalValueChange(e); this.closeModal()}} className={this.props.mentalValue === 'mental-1'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["mental-1"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["mental-1-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="mental-2" name="mental" onClick={(e)=>{this.props.mentalValueChange(e); this.closeModal()}} className={this.props.mentalValue === 'mental-2'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["mental-2"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["mental-2-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="mental-3" name="mental" onClick={(e)=>{this.props.mentalValueChange(e); this.closeModal()}} className={this.props.mentalValue === 'mental-3'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["mental-3"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["mental-3-i"]}</div>
                            </div>
                          </div>
                      </div>
                      <div className="modal-indicator-radio">
                        <div style={{display: "flex", alignItems: "center"}}>
                          <div>
                            <Button type="button" value="mental-4" name="mental" onClick={(e)=>{this.props.mentalValueChange(e); this.closeModal()}} className={this.props.mentalValue === 'mental-4'?"radio selected":"radio"} />
                          </div>
                          <div className="modal-indicator-label">
                            {Indicator["mental-4"]}
                          </div>
                        </div>
                        <div>
                            <div class="tooltip"><img style={{width: "15px", height: "15px"}} src="info-light.png" />
                              <div class="tooltiptext"><span style={{fontWeight: "bold"}}>More Information - </span>
                              {Indicator["mental-4-i"]}</div>
                            </div>
                          </div>
                      </div>
                    </div>
                  ):""
                }
              </div>
            )
          }
        </Modal>
  )}
}




export default ModalView;

//export default ModalView;



// WEBPACK FOOTER //
// ./src/components/IndicatorModal.js